<template>
  <button
    type="button"
    class="btn btn-default filter-button"
    :class="{ 'active' : active }"
  >
    {{ name }}
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: ['name', 'active'],
};
</script>

<style scoped>
.btn, .btn:hover, .btn:focus, .btn:active {
  background-color: #ffffbb;
  outline: none;
}

.filter-button.active,
.filter-button.active:hover,
.filter-button.active:active {
  background: #7CCFEB;
}

.filter-button{
  font-size: 16px;
}
</style>
